export default class TripleImg {
  constructor(el) {
    this.el = el
    this.imgs = [...el.querySelectorAll('.triple-img--img')]
    this.speeds = [0.1, 0.2, 0.15]
    this.ticking = false
    this.init()
  }

  init() {
    if (!this.imgs.length) return
    window.addEventListener('scroll', () => this.onScroll(), { passive: true })
    this.parallax()
  }

  onScroll() {
    if (this.ticking) return
    this.ticking = true
    requestAnimationFrame(() => {
      this.parallax()
      this.ticking = false
    })
  }

  parallax() {
    const rect = this.el.getBoundingClientRect()
    if (rect.bottom < 0 || rect.top > window.innerHeight) return

    // Parallax atténué sur mobile (rendu plus stable)
    const factor = window.innerWidth <= 768 ? 0.25 : 1

    this.imgs.forEach((img, i) => {
      img.style.transform = `translateY(${rect.top * this.speeds[i] * factor}px)`
    })
  }
}
